import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import {
  fetchFeatureConfiguration,
  saveFeatureConfiguration,
} from "src/Pages/Company/Absences/api";

export interface IFeatureConfiguration {
  featuresConfigurations: {
    [key: string]: {
      wholeCompany: boolean;
    };
  };
}

export const useFetchFeatureConfiguration = (companyId: string) =>
  useQuery<IFeatureConfiguration, Error>({
    enabled: !!companyId,
    queryKey: ["absence-configuration", { companyId }],
    queryFn: async () => fetchFeatureConfiguration(companyId),
  });

export const useSaveFeatureConfiguration = (companyId: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (formData: IFeatureConfiguration) => {
      const result = await saveFeatureConfiguration(companyId, formData);

      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["absence-configuration", { companyId }],
      });

      dynamicNotification(__("Pomyślnie zapisano konfigurację."));
    },
    onError: () => {
      dynamicNotification(
        __("Nie udało się zapisać danych."),
        "error",
        "top-right",
        7000
      );
    },
  });

  return mutation;
};
